

import { Component } from '@angular/core';




@Component({

    selector: 'consumerLko-cmp',
    templateUrl: './consumerLko.component.html',
    styleUrls: ['./consumerLko.component.css'],
   
  })
export class ConsumerLkoComponent {
  
}


// WEBPACK FOOTER //
// ./src/app/crm/kccLko/consumerLko/consumerLko.component.ts